import { render, staticRenderFns } from "./DomicilioTabContent.vue?vue&type=template&id=0db09027"
import script from "./DomicilioTabContent.vue?vue&type=script&lang=js"
export * from "./DomicilioTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports